// src/features/home/merchantListingSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

// 🔹 GET all merchants list
export const fetchMerchantsThunk = createAsyncThunk(
  "merchantListing/fetchMerchants",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/list/merchants-list");
      return res.data.data; // merchants + banners
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load merchants");
    }
  }
);

// 🔹 GET single merchant detail
export const fetchMerchantDetail = createAsyncThunk(
  "merchantListing/fetchMerchantDetail",
  async (merchantId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/list/merchant-detail/${merchantId}`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to load merchant detail");
    }
  }
);

const initialState = {
  merchants: [],
  customizedBanners: [],
  merchantDetail: null,   // ⭐ added
  loading: false,
  error: null,
};

const merchantListingSlice = createSlice({
  name: "merchantListing",
  initialState,
  reducers: {
    clearMerchantDetail: (state) => {
      state.merchantDetail = null;
    }
  },
  extraReducers: (builder) => {
    builder

      // 🔹 Merchant List
      .addCase(fetchMerchantsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMerchantsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.merchants = action.payload.merchants || [];
        state.customizedBanners = action.payload.customizedBanners || [];
      })
      .addCase(fetchMerchantsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🔹 Merchant Detail
      .addCase(fetchMerchantDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMerchantDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.merchantDetail = action.payload;
      })
      .addCase(fetchMerchantDetail.rejected, (state, action) => {
        state.loading = false;

        // backend 401 unauthorized
        if (action.payload?.status === 401) {
          state.error = "Unauthorized — Login required";
        } else {
          state.error = action.payload || "Failed to load merchant detail";
        }
      });
  },
});

// Export actions
export const { clearMerchantDetail } = merchantListingSlice.actions;

// Export reducer
export default merchantListingSlice.reducer;
